import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../i18n/index.js";

/** Our mark: three stacked server bars (same drawing as the app icons). */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden>
      <rect width="64" height="64" rx="14" fill="#0b1220" />
      {["#2dd4bf", "#38bdf8", "#818cf8"].map((color, i) => (
        <g key={color}>
          <rect x="11.5" y={16 + i * 13.5} width="41" height="10" rx="3.5" fill={color} />
          <circle cx="47" cy={21 + i * 13.5} r="1.6" fill="#f0fdfa" />
        </g>
      ))}
    </svg>
  );
}

/**
 * Logo and name. `collapse`: the name shows from 420 px up only — on a
 * narrower phone the top bar has room for the mark alone (the link around it
 * carries the name for screen readers).
 */
export function Wordmark({ collapse = false }: { collapse?: boolean }) {
  const { t } = useTranslation();
  return (
    <span className="flex items-center gap-2 font-semibold tracking-tight">
      <Logo />
      <span className={collapse ? "hidden min-[420px]:inline" : undefined}>{t("app.name")}</span>
    </span>
  );
}

export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  return (
    <label className="flex items-center gap-1 text-sm text-muted">
      <span className="sr-only">{t("common.language")}</span>
      <select
        value={i18n.resolvedLanguage}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        className="rounded-md border border-line bg-surface px-2 py-1 text-sm text-text"
      >
        {LANGUAGES.map((lng) => (
          <option key={lng} value={lng}>
            {lng === "en" ? "English" : "Русский"}
          </option>
        ))}
      </select>
    </label>
  );
}
